<template>
  <div>
    <b-card header-class="border-0">
      <b-row>
        <b-col>
          <base-input label="Patient">
            <customerSelect v-on:nameSelected="nameSelected"></customerSelect>
            <small>Search by first name or e-mail</small>
          </base-input>
        </b-col>
        <b-col>
          <label class="form-control-label">Start Date</label>
          <b-form-datepicker
            id="startDate"
            v-model="form.startDate"
                       class="col-sm-12"
            locale="en"
          ></b-form-datepicker>
        </b-col>
        <b-col>
          <label class="form-control-label">End Date</label>
          <b-form-datepicker
            id="endDate"
            v-model="form.endDate"
                       class="col-sm-12"
            locale="en"
          ></b-form-datepicker>
        </b-col>
        <b-col>
          <label class="form-control-label">Payment Status</label>
                    <b-form-radio-group
            :options="paymentStatuses"
            v-model="form.paymentStatus"
            stacked
          />
        </b-col>
        </b-col>
      </b-row>
    </b-card>

    <b-card body-class="p-0" header-class="border-0">
      <notification-search-results :query="form" />
    </b-card>
  </div>
</template>
<script>
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import NotificationSearchResults from "@/views/Components/Notifications/SearchResults";

import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";

export default {
  name: "light-table",
  title: "Payment Requests",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    flatPicker,
    NotificationSearchResults,
  },
  props: {
    itemLimit: {
      type: Number,
      default: 9,
    },
  },
  data() {
    return {
      paymentStatuses: [
        { value: "PAID", text: "Paid" },
        { value: "NOTPAID", text: "Not Paid" },
      ],
      form: {
        paymentStatus: "NOTPAID",
        startDate: null,
        endDate: null,
        customerId: null,
      },
    };
  },
  methods: {
    nameSelected(customer) {
      this.form.customerId = customer.id;
    },
    query() {},
  },
};
</script>